import { render } from "./GrapesUploadPage.vue?vue&type=template&id=dee54d86"
import script from "./GrapesUploadPage.vue?vue&type=script&lang=js"
export * from "./GrapesUploadPage.vue?vue&type=script&lang=js"
script.render = render

export default script